import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, ValidateContext } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetUseOneTimeAddress";
import { getIsCanadaWebsite } from "@midland-industries/Components/WebsiteSelector";

/**
 * Change Log:
 * 20241025: Added override to allow changing Shipping/Billing addresses when FulfillmentMethod.PickUp.
 */
type SetUseOneTimeAddressProps = Parameters<typeof ValidateContext>[0];

function CustomValidateContext(props: SetUseOneTimeAddressProps) {    
    const state = props.getState();
    const {
        context: { session },
    } = state;
    
    const isCanada = getIsCanadaWebsite(state);    
    const { allowOneTimeAddresses } = getSettingsCollection(state).customerSettings;
    
    if (isCanada) {
        if (session.fulfillmentMethod === FulfillmentMethod.PickUp) {
            throw new Error("A shipping address does not apply to a pickup order.");
        }
    }

    if (!allowOneTimeAddresses) {
        throw new Error("This action can only be performed if creating one-time addresses is allowed.");
    }
}

replaceInChain(chain, ValidateContext, CustomValidateContext);

